import {
  Button,
  Center,
  Divider,
  Flex,
  Group,
  Highlight,
  Stack,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { useAuth } from "../../context/auth";
import { TagCapsules, SectionsForm, FinishStep } from "../../components";
import ProductPlans from "./ProductPlans";
import { IColor } from "../../utils/selectColors";
import { InfoCircle } from "iconsax-react";
import { useFormContext } from "react-hook-form";
import { IPostBuyPlan } from "../../interfaces/Purchase";
import { client_selected } from "../../client";
import { useTranslation } from "react-i18next";
import {
  tradutorCategory,
  tradutorSubcategory,
} from "../../utils/SubCategorys";

const PurchaseStep2 = () => {
  const { t } = useTranslation();
  const { interest, setInterest } = useAuth();
  const theme = useMantineTheme();
  const name = client_selected.name;
  const selectedInterest = interest.filter((item) => item.selected);

  const {
    watch,
    formState: { errors },
  } = useFormContext<IPostBuyPlan>();

  const hasDirtyFirst =
    !!watch("payment_owner.name") &&
    !!watch("payment_owner.document_nr") &&
    !!watch("payment_owner.address.zip_code") &&
    !!watch("payment_owner.address.city") &&
    !!watch("payment_owner.address.state") &&
    !!watch("payment_owner.address.country") &&
    !!watch("payment_owner.address.street") &&
    !!watch("payment_owner.address.neighborhood") &&
    !!watch("payment_owner.address.number");

  const handleDelete = (index: number) => {
    setInterest((prev) =>
      prev.map((item, i) => (i === index ? { ...item, selected: false } : item))
    );
  };

  return (
    <SectionsForm
      title={t("marketplace.comprar_serviços.purchase_step_2.title_section")}
      number={"02"}
    >
      {!!errors?.plans?.message ? (
        <Flex
          gap="10px"
          bg="alertsOpacity.0"
          p="10.5px 0"
          w="100%"
          align="center"
          justify="center"
          sx={{ borderRadius: "8px" }}
        >
          <Tooltip
            multiline
            w={236}
            label={errors?.plans?.message}
            withArrow
            transitionProps={{ duration: 200 }}
          >
            <InfoCircle size={24} color={theme.colors.alerts[0]} />
          </Tooltip>
          <Highlight
            highlight={["24 Horas"]}
            size={12}
            lh="19px"
            color="alerts.0"
            fw={500}
            sx={{
              "& [data-highlight]": {
                backgroundColor: "unset",
                fontWeight: 700,
              },
            }}
          >
            {errors?.plans?.message}
          </Highlight>
        </Flex>
      ) : null}
      {hasDirtyFirst ? (
        selectedInterest.map((item, index) => {
          return (
            <Flex
              key={index}
              gap="32px"
              w="100%"
              justify="space-between"
              direction={"column"}
            >
              {index !== 0 && <Divider variant="dashed" />}
              <Flex direction="column" gap="0" w="100%">
                {/* Cabeçalho */}
                <Group
                  sx={(theme) => ({
                    backgroundColor: theme.colors.gray[1],
                    borderRadius: "12px 12px 0px 0px",
                    padding: "8px 16px",
                    justifyContent: "space-between",
                    width: "100%",
                  })}
                >
                  <Text weight={600} size="lg" color="dark">
                    {t("marketplace.comprar_serviços.purchase_step_2.product")}{" "}
                    {index + 1}
                  </Text>
                  <Button
                    variant="dangerTransparent"
                    onClick={() => handleDelete(index)}
                    w="fit-content"
                    disabled={selectedInterest.length === 1}
                  >
                    {t("marketplace.comprar_serviços.purchase_step_2.remove")}
                  </Button>
                </Group>

                {/* Conteúdo do Produto */}
                <Flex direction="column" gap="32px" w="100%" p="16px 16px 0">
                  <Flex justify={"space-between"} gap="md">
                    <Flex align="center" gap="md">
                      <Flex gap="16px" align="center">
                        <Flex
                          w="60px"
                          h="60px"
                          sx={{
                            backgroundImage: `url(${item.product.icon})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: "12px",
                          }}
                        />

                        <Stack spacing={4}>
                          <Flex gap="8px">
                            <TagCapsules colorTag={IColor.orange} border>
                              {t(tradutorCategory(item.product.category).title)}
                            </TagCapsules>
                            {item.product.subcategory ? (
                              <TagCapsules colorTag={IColor.yellow} border>
                                {t(
                                  tradutorSubcategory(item.product.subcategory)
                                    .title
                                )}
                              </TagCapsules>
                            ) : null}
                          </Flex>
                          <Text weight={700} size="xl" color="dark">
                            {item.product.title}
                          </Text>
                        </Stack>
                      </Flex>

                      <Stack spacing={0}>
                        <Text color="gray" size="sm">
                          {t(
                            "marketplace.comprar_serviços.purchase_step_2.sell_by"
                          )}
                        </Text>
                        <Text color="dark" weight={600} size="sm">
                          {item.product?.partner?.name ?? name}
                        </Text>
                      </Stack>

                      {/* removido na reunião do dia 04/06/2025 porque não tinha retorno na api */}
                      {/* <Stack spacing={0}>
                        <Text color="gray" size="sm">
                          Periodicidade
                        </Text>
                        <Text color="dark" weight={600} size="sm">
                          Pagamento recorrente (mensal)
                        </Text>
                      </Stack> */}
                    </Flex>
                  </Flex>

                  <ProductPlans product={item} />
                </Flex>
              </Flex>
            </Flex>
          );
        })
      ) : (
        <FinishStep />
      )}
    </SectionsForm>
  );
};
export default PurchaseStep2;
